/*
 * Cart upsell — handler del botón "Agregar".
 * Agrega el producto al carrito vía AJAX (/cart/add.js) con la line item
 * property `_from_cart_upsell="true"`. Esa property activa la Shopify
 * Function "Upsell Carrito - 2 productos" que aplica 25% off automático.
 */
(function () {
  if (window.__cartUpsellInit) return;
  window.__cartUpsellInit = true;
  console.info("[cart-upsell] init");

  async function addUpsellToCart(variantId, quantity) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: parseInt(variantId, 10),
            quantity: quantity || 1,
            properties: { _from_cart_upsell: "true" },
          },
        ],
      }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || "No se pudo agregar al carrito");
    }
    return res.json();
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("theme:cart:refresh"));
    document.dispatchEvent(new CustomEvent("ajaxProduct:added"));
    if (window.theme && window.theme.cart && typeof window.theme.cart.refresh === "function") {
      try { window.theme.cart.refresh(); } catch (e) { /* noop */ }
    }
  }

  // Capture phase so other listeners (theme cart drawer) can't stopPropagation us first.
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest && e.target.closest("[data-cart-upsell-add]");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    console.info("[cart-upsell] click", btn);

    const item = btn.closest(".cart-upsell__item");
    const sizeEl = item ? item.querySelector("[data-cart-upsell-size]") : null;
    const variantId = sizeEl ? sizeEl.value : null;

    if (!variantId) {
      console.warn("[cart-upsell] No variant selected");
      return;
    }

    if (!btn.dataset.originalLabel) {
      btn.dataset.originalLabel = btn.textContent.trim();
    }

    btn.disabled = true;
    btn.textContent = "Agregando…";
    btn.removeAttribute("data-state");

    try {
      await addUpsellToCart(variantId, 1);
      btn.dataset.state = "added";
      btn.textContent = "✓ Agregado";
      refreshCartUI();
      setTimeout(() => {
        btn.removeAttribute("data-state");
        btn.textContent = btn.dataset.originalLabel;
        btn.disabled = false;
      }, 1800);
    } catch (err) {
      console.error("[cart-upsell]", err);
      btn.textContent = btn.dataset.originalLabel;
      btn.disabled = false;
    }
  }, true);
})();
